
























































































































































import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';

import CouponAPI from '@/services/CouponAPI';

import Coupon from '@/types/Coupon';
import Amount from '@/types/Amount';
import PromotionCoupon from '@/form/PromotionCoupon';

import Field from '@/components/Bulma/Field.vue';
import TInput from '@/components/Bulma/TInput.vue';
import LanguageSelectorTab from '@/components/LanguageSelectorTab.vue';
import Loader from '@/components/Loader.vue';
import Util from '@/util/Util';

export default Vue.extend({
    name: 'CouponEditor',

    components: {
        Field,
        TInput,
        LanguageSelectorTab,
        Loader
    },

    data() {
        return {
            coupon: new Coupon(),
            coupons: new Array<Coupon>(),
            status: '',
            isSaving: false,
            isLoading: false,
            promotionCouponId: '',
            promotionCoupon: new PromotionCoupon(),
            exampleHtmlEmail: '',
            isLoadingExample: false,
            isLoadingEmail: false,
            statusEmail: ''
        };
    },

    computed: {
        ...mapState(['language'])
    },

    created() {
        this.coupon.couponDescription = new Map<string, string>();
        this.coupon.amountDiscount = new Amount();
        this.coupon.minimumOrderValueAllowed = new Amount();
        this.loadCoupons();
    },

    methods: {
        postCoupon(): void {
            this.status = '';
            if (!this.coupon.startDateTime || this.coupon.startDateTime.toString() === '' ||
                 !this.coupon.endDateTime || this.coupon.endDateTime.toString() === '') {
                this.status = 'Valid from or valid to can\'t be empty';
                return;
            }
            const handleResponse = (response: AxiosResponse) => {
                    this.loadCoupons();
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.status = error.response.data.message;
                    }
                };

            this.isSaving = true;
            CouponAPI
                .post(this.coupon)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isSaving = false);
        },

        loadCoupons(): void {
            this.status = '';
            const handleResponse = (response: AxiosResponse) => {
                    this.coupons =  response.data;
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.status = error.response.data.message;
                    }
                };

            this.isLoading = true;
            CouponAPI
                .get()
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoading = false);
        },

        deleteCoupon(couponId: string): void {
            const handleResponse = (response: AxiosResponse) => {
                    this.loadCoupons();
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.status = error.response.data.message;
                    }
                };

            CouponAPI
                .delete(couponId)
                .then(handleResponse)
                .catch(handleError);
        },

        getExamplePromotionalCouponEmail(couponId: string, promotionCoupon: PromotionCoupon): void {
            if (Util.isEmpty(couponId)) {
                alert('Need to enter CouponId first!');
                return;
            }

            const handleResponse = (response: AxiosResponse) => {
                    this.exampleHtmlEmail = response.data;
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.status = error.response.data.message;
                    }
                };

            this.isLoadingExample = true;
            CouponAPI
                .getExamplePromotionalCouponEmail(couponId, promotionCoupon)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoadingExample = false);
        },

        sendPromotionalCouponEmail(couponId: string, promotionCoupon: PromotionCoupon): void {
            if (Util.isEmpty(couponId)) {
                alert('Need to enter CouponId first!');
                return;
            }

            if (!confirm('Are you sure you want to send email to all users?')) {
                return;
            }

            const handleResponse = (response: AxiosResponse) => {
                    this.exampleHtmlEmail = '';
                    this.statusEmail = 'Email sent to ' + response.data + ' users';
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.status = error.response.data.message;
                    }
                };

            this.isLoadingEmail = true;
            CouponAPI
                .sendPromotionalCouponEmail(couponId, promotionCoupon)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoadingEmail = false);
        }
    }
});
